// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_hp","advertDetailService__price":"c-o_hq"};